import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class ExcelReportFees {
    exportExcel(dataFees) {
        let option = {};  // La opción representa el archivo de Excel
        let optionsData = [];

        console.log("dataFees: ",dataFees);
        for(let x = 0; x < dataFees.length; x++) {
            let feeProfesional = this.feesVerify(dataFees[x]);
            let sheetProfesional = {
                sheetData: feeProfesional.data,  // Fuente de datos en archivo Excel
                sheetName: dataFees[x].nombre_profesional, // nombre de la página de hoja en el archivo de Excel
            }
            optionsData.push(sheetProfesional);
        }

        option.fileName = 'Honorarios';  // Nombre del archivo Excel
        option.datas = optionsData;
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    feesVerify(dataFee) {
        let dataTable = [];

        let casillaVacia = this.generarEspaciador();
        dataTable.push(casillaVacia);

        let casillaFechaInicial = this.generarCasillaFechaInicial(dataFee.fecha_inicial);
        dataTable.push(casillaFechaInicial);
        
        let casillaFechaFinal = this.generarCasillaFechaFinal(dataFee.fecha_final);
        dataTable.push(casillaFechaFinal);

        let casillaDoctor = this.generarCasillaDoctor(dataFee.nombre_profesional);
        dataTable.push(casillaDoctor);

        dataTable.push(casillaVacia);

        let titulos = this.generarCasillaTitulos();
        dataTable.push(titulos);

        let subtotalHonorario = 0;
        let retencionHonorario = 0;//10%
        let totalHonorario = 0;

        for(let i = 0; i < dataFee.honorarios_profesional.length; i++)
        {
            let casillaHonorario = this.generarCasillaHonorario(dataFee.honorarios_profesional[i]);
            subtotalHonorario = parseInt(subtotalHonorario) + parseInt(dataFee.honorarios_profesional[i].liquidacion);
            dataTable.push(casillaHonorario);
        }

        retencionHonorario = parseInt(subtotalHonorario) * 0.1;
        totalHonorario = parseInt(subtotalHonorario) - parseInt(retencionHonorario);

        dataTable.push(casillaVacia);

        let casillaHonorarioValor = this.generarCasillaHonorarioValor(subtotalHonorario);
        dataTable.push(casillaHonorarioValor);

        let casillaHonorarioRetencion = this.generarCasillaHonorarioRetencion(retencionHonorario);
        dataTable.push(casillaHonorarioRetencion);

        let casillaHonorarioNetoPagar = this.generarCasillaHonorarioNetoPagar(totalHonorario);
        dataTable.push(casillaHonorarioNetoPagar);

        let sheet =
        {
            data: dataTable
        }
        return sheet;
    }

    generarEspaciador() {
        let casillas = {
            '1': ""
        }
        return casillas;
    }

    generarCasillaFechaInicial(fecha_inicial) {
        let casillas = {
            '1': "Fecha Inicial",
            '2': moment(fecha_inicial).format("DD/MM/YYYY"),
        }
        return casillas;
    }

    generarCasillaFechaFinal(fecha_final) {
        let casillas = {
            '1': "Fecha Final",
            '2': moment(fecha_final).format("DD/MM/YYYY"),
        }
        return casillas;
    }
    
    generarCasillaDoctor(nombre_profesional) {
        let casillas = {
            '1': "Profesional",
            '2': nombre_profesional,
        }
        return casillas;
    }

    generarCasillaTitulos() {
        let casillas = {
            '1': "Paciente",
            '2': "Fecha Admision",
            '3': "Servicio",
            '4': "Entidad",
            '5': "Valor",
            '6': "Pactado",
            '7': "Total"
        }
        return casillas;
    }

    generarCasillaHonorario(dataHonorario) {
        let casillas = {
            '1': dataHonorario.nombre_paciente,
            '2': moment(dataHonorario.fecha_admision).format("DD-MM-YYYY hh:mm"),
            '3': dataHonorario.nombre_servicio,
            '4': dataHonorario.nombre_tercero,
            '5': dataHonorario.costo_servicio,
            '6': dataHonorario.pactado,
            '7': dataHonorario.liquidacion
        }
        return casillas;
    }

    calcularRetencionHonorario(valor)
    {
        let retencion = parseInt(valor) * 0.1;
        let liquidacion = {
            subtotal : parseInt(valor),
            pactado : parseInt(retencion),
            total : parseInt(valor) - parseInt(retencion)
        }
        return liquidacion;
    }

    generarCasillaHonorarioValor(valor)
    {
        let casillas = {
            '1': "Honorario",
            '2': valor,
        }
        return casillas;
    }

    generarCasillaHonorarioRetencion(valor)
    {
        let casillas = {
            '1': "Retencion 10%",
            '2': valor,
        }
        return casillas;
    }

    generarCasillaHonorarioNetoPagar(valor)
    {
        let casillas = {
            '1': "Neto a Pagar",
            '2': valor,
        }
        return casillas;
    }

}

export default new ExcelReportFees();